import { render } from "./activityManager.vue?vue&type=template&id=7a8a4c05&scoped=true"
import script from "./activityManager.vue?vue&type=script&lang=js"
export * from "./activityManager.vue?vue&type=script&lang=js"

import "./activityManager.vue?vue&type=style&index=0&id=7a8a4c05&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a8a4c05"]])

export default __exports__